import {withStyles} from 'native-components-infra/dist/es/src'
import {App} from './app'

export default {
  component: withStyles(App, {ltrCssPath: 'eventsWidget.min.css', rtlCssPath: 'eventsWidget.rtl.min.css'})
}
